import React, {useState, useContext, useEffect} from 'react';
import { IonMenu, IonHeader, IonToolbar, IonTitle, IonButtons, IonMenuButton, IonContent, IonList, IonMenuToggle, IonItem, IonLabel, IonButton, IonIcon, useIonRouter } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { useHistory} from "react-router-dom";



export function Retail_SideMenu (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let history = useHistory();
    let router = useIonRouter();

    function handleRoute(event)
    {
        // alert(event);
        // alert(window.location.pathname);

        //history.push(event);
        router.push(event, 'forward', 'replace');

        if(event == '/logout')
        {
            window.location.href = event;
        }

    }

    //alert("IN SIDE MENUI");

        return (
               // <IonRouterOutlet>
               <React.Fragment>
               {authenticatedMerchent_context.accessRights != null &&
                <IonMenu menuId="side_menu_hotel" contentId='qavaAppConfirmed' type='overlay' side='end'>
                    <IonHeader>
                            <IonToolbar> 
                                <IonTitle>
                                    Menu
                                </IonTitle>
                                <IonButtons slot='end'>
                                    <IonMenuButton >X</IonMenuButton>
                                </IonButtons>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent>
                            <IonList>
                                <IonMenuToggle auto-hide='false'>
                                        <IonItem button onClick={() => handleRoute('/retail_merchantMainPageApp' )}>
                                            Home
                                        </IonItem>
                                </IonMenuToggle>
                                <IonMenuToggle auto-hide='false'>
                                        <IonItem button onClick={() => handleRoute('/retail_profileSetting' )}>
                                            Profile
                                        </IonItem>
                                </IonMenuToggle>
                               <IonMenuToggle auto-hide='false' >                                           
                                {authenticatedMerchent_context.initialSetup?.details?.step_1 == false && <IonItem button className='flash-tutorial' onClick={() => handleRoute('/retail_accountSetting' )}>
                                            Account
                                        </IonItem>}
                                {authenticatedMerchent_context.initialSetup?.details?.step_1 == true && <IonItem button onClick={() => handleRoute('/retail_accountSetting' )}>
                                            Account
                                        </IonItem>}
                                </IonMenuToggle>
                                <IonMenuToggle auto-hide='false'>
                                        <IonItem button onClick={() => handleRoute('/retail_tutorials' )}>
                                            Tutorials
                                        </IonItem>
                                </IonMenuToggle>
                                <IonMenuToggle auto-hide='false'>
                                        <IonItem button onClick={() => handleRoute('/logout' )}>
                                            Logout
                                        </IonItem>
                                </IonMenuToggle>
                            </IonList>               
                        </IonContent>
                    </IonMenu>}
                    </React.Fragment>
                //</IonRouterOutlet>
        )
    }